import React from 'react';
import './index.scss';
import ProgressComponent from '../ProgressComponent';
const ProgressCard = (porps: any) => {
  let { data } = porps;
  return (
    <div className="dbi-progress-card">
      <div className="progress-text">{data?.title}</div>
      {data?.list.map((e: any, i: any) => {
        return (
        <ProgressComponent key={i} data={e} />
        );
      })}
  </div>
  );
};

export default ProgressCard;
